import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionEncargadospldEditarComponent {
  constructor ($state, ClienteInformacionEncargadopld) {
    this.$state = $state
    this.ClienteInformacionEncargadopld = ClienteInformacionEncargadopld
    this.idCliente = null
    this.idEncargadopld = null
    this.onClose = null
    this.error = null
    this.catalogos = {}
    this.procesando = false
  }

  $onInit () {
    this.promise = this.ClienteInformacionEncargadopld.get(this.idCliente, this.idEncargadopld)
      .then(({data}) => (this.data = data))
  }

  actualizar () {
    if (this.procesando) return

    this.procesando = true
    this.error = null

    this.ClienteInformacionEncargadopld.put(this.idCliente, this.idEncargadopld, this.data)
      .then(() => (this.cerrar()))
      .catch(({data}) => (this.error = data))
      .finally(() => (this.procesando = false))
  }

  cerrar () {
    this.$state.go('cliente.informacion.encargadospld')
  }
}

module.component('clienteInformacionEncargadospldEditar', {
  controller: ClienteInformacionEncargadospldEditarComponent,
  template,
  bindings: {
    idCliente: '<',
    idEncargadopld: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/encargadospld/editar/component.js